<template>
    <div class="video-segment">
        <figure>
            <div class="video-segment__container">
                <div v-if="isIframe" class="embed-video">
                    <div class="container"><iframe :src="parsePath" frameborder="0"></iframe></div>
                </div>
                <video
                    v-if="!isIframe"
                    ref="video"
                    :src="segmentData.path"
                    :poster="segmentData.poster"
                    :title="segmentData.title"
                    loop
                    muted
                    autoplay
                    playsinline
                ></video>
                <div class="video-segment__controls" v-if="!isIframe">
                    <button class="video-segment__button" @click="togglePictureInPicture" type="button" v-if="supportsPictureInPicture">
                        <ProIcon icon="picture-in-picture" />
                    </button>

                    <button class="video-segment__button" @click="mute" type="button" v-if="controls.mute">
                        <ProIcon v-if="muted" icon="sound-muted" />
                        <ProIcon v-else icon="sound-active" />
                    </button>
                </div>
            </div>
            <figcaption class="video-segment__caption">{{ segmentData.caption }}</figcaption>
        </figure>
    </div>
</template>

<script>
export default {
    props: {
        id: String,
        segmentData: Object,
    },

    data: () => ({
        muted: false,
        supportsPictureInPicture: false,
    }),

    computed: {
        isIframe() {
            const isMatch = this.segmentData.path.match(
                /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
            );

            return isMatch && (RegExp.$3.indexOf("youtu") > -1 || RegExp.$3.indexOf("vimeo") > -1);
        },

        parsePath() {
            return this.segmentData.path;
        },

        controls() {
            return this.segmentData.controls || {};
        },
    },

    methods: {
        volumeChanged(event) {
            this.muted = this.$refs.video.muted;
        },

        mute() {
            this.$refs.video.muted = !this.$refs.video.muted;
        },

        togglePictureInPicture() {
            this.$refs.video.webkitSetPresentationMode(this.$refs.video.webkitPresentationMode === "picture-in-picture" ? "inline" : "picture-in-picture");
        },

        isPictureInPictureSupported() {
            return this.$refs.video && this.$refs.video.webkitSupportsPresentationMode && typeof this.$refs.video.webkitSetPresentationMode === "function";
        },
    },

    mounted() {
        if (this.$refs.video) {
            this.muted = this.$refs.video.muted;
            this.supportsPictureInPicture = this.isPictureInPictureSupported();

            this.$refs.video.addEventListener("volumechange", this.volumeChanged);
        }
    },

    beforeDestroy() {
        if (this.$refs.video) {
            this.$refs.video.removeEventListener("volumechange", this.volumeChanged);
        }
    },
};
</script>
